import React from 'react';
import config from 'react-global-configuration';

import ViewRecentContentOverviewBuurtboerderij from './Buurtboerderij';
import ViewRecentContentOverviewRegenboog from './Regenboog';

const ViewRecentContentOverview = (props) => {
  const currentDomain = config.get('CURRENT_DOMAIN');

  switch (currentDomain) {
    case 'buurtboerderij': {
      return <ViewRecentContentOverviewBuurtboerderij {...props} />;
    }

    case 'regenboog':
    default: {
      return <ViewRecentContentOverviewRegenboog {...props} />;
    }
  }
};

export default ViewRecentContentOverview;
